
export enum SectionVisible {
  Course = 'courses',
  Group = 'groups',
  Direct = 'direct'
}
